export const GET_ALL_CARD_DETAILS = 'GET_ALL_CARD_DETAILS'
export const GET_CARD_DETAILS = 'GET_CARD_DETAILS'
export const GET_ALL_PAYMENT_METHOD_CARD_DETAILS = 'GET_ALL_PAYMENT_METHOD_CARD_DETAILS'
export const GET_PAYMENT_METHOD_CARD_DETAILS = 'GET_PAYMENT_METHOD_CARD_DETAILS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
